<script>
import { Line } from 'vue-chartjs';

export default {
  name: 'BaseLineChart',
  mixins: [Line],
  props: {
    labels: {
      type: Array,
      required: true,
    },
    dataSets: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.drawChart();
  },
  watch: {
    dataSets() {
      this.drawChart();
    },
  },
  methods: {
    drawChart() {
      this.renderChart({
        labels: this.labels,
        datasets: this.dataSets,
      }, {
        legend: {
          position: 'bottom',
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              labelString: 'Note',
              display: true,
            },
            ticks: {
              min: 0,
              max: 20,
            },
          }],
          xAxes: [{
            ticks: {
            },
          }],
        },
      }, [{ label: 'Note' }]);
    },
  },
};
</script>
